import { Spin as AntSpin } from "antd"
import React from "react"
import styled from "styled-components"
const SpinOuter = styled.div`
  max-width: 52rem;
  height: 40rem;
  display: flex;
  justify-content: center;
  align-items: center;
`
const Spiner = styled(AntSpin)`
  min-width: 100%;
  min-height: 100%;
  margin-top: 50vh;
`

export const Spin = () => {
  return (
    <SpinOuter>
      <Spiner size="large" tip="Loading..." />
    </SpinOuter>
  )
}
